export default {
  site: {
    title: "成都寰宇纵横国际旅行社有限公司",
  },
  lang: {
    switch: "EN",
    zh: "中文",
    en: "English",
  },
  header: {
    phone: "15114070473",
    email: "hz@pangod.com",
  },
  search: {
    placeholder: "搜索目的地...",
    submit: "搜索",
    title: "目的地检索",
    enterKeyword: "请输入目的地名称或城市进行检索",
    noResults: "未找到相关目的地，请换个关键词试试",
    resultCount: "共找到 {count} 条与「{q}」相关的结果",
    types: {
      page: "页面",
      destination: "目的地",
      guide: "旅游服务",
      strategy: "游玩攻略",
      banner: "推荐目的地",
    },
  },
  nav: {
    home: "首页",
    planTrip: "定制我的旅程",
    destinations: "目的地",
    travelThemes: "旅行主题",
    testimonials: "客户评价",
    contact: "联系我们",
    about: "关于我们",
    destSichuan: "四川",
    destChongqing: "重庆",
    destBeijing: "北京",
    destXian: "西安",
    guide: "旅游指南",
    strategy: "游玩攻略",
    bcfw: "包车服务",
    cjly: "酒店预订",
    gnly: "门票预订",
    qydz: "中国味道",
    qzbl: "签证办理",
    srdz: "主题旅游",
  },
  planTrip: {
    title: "定制我的旅程",
    en: "PLAN MY TRIP",
    heroTitle: "定制旅行",
    heroEn: "Customized Travel",
    steps: [
      { title: "提交需求" },
      { title: "获取方案" },
      { title: "沟通行程" },
      { title: "签约合同" },
    ],
    cta: "立即定制",
    servicesTitle: "我们可提供的服务",
    services: [
      {
        title: "个性化定制",
        desc: "按你的喜好量身打造，想去哪、怎么玩，你说了算",
      },
      {
        title: "资深定制师",
        desc: "100+专业定制师，人均千次实操经验，懂目的地更懂你",
      },
      {
        title: "免费制作行程方案",
        desc: "不花一分钱，提供专业行程建议，自由行的安全感直接拉满",
      },
      {
        title: "一站式服务",
        desc: "不用查攻略、不用比酒店、不用盯车导，我们全包了，你只管出发",
      },
    ],
  },
  footer: {
    companyName: "公司名称：成都寰宇纵横国际旅行社有限公司",
    phone: "联系手机：15114070473",
    address: "联系地址：四川省成都市锦江区东大路318号2栋37层",
    copyright: "成都寰宇纵横国际旅行社有限公司 版权所有",
  },
  common: {
    backTop: "回到顶部",
    home: "首页",
    publishedAt: "发表时间：",
  },
  home: {
    banner: [
      {
        tag: "漫游中国",
        title: "四川",
        sub: "风光旖旎的天府胜地，汇集奇绝秀美山川盛景与安逸悠然的巴蜀韵味",
      },
      {
        tag: "漫游中国",
        title: "重庆",
        sub: "一座热情奔放的山水江城，坐拥雄奇险峻的山城地貌与热辣浓郁的市井风情",
      },
      {
        tag: "漫游中国",
        title: "北京",
        sub: "底蕴深厚的千年古都，兼具恢弘大气的皇城风貌与兼容并蓄的时代风华",
      },
      {
        tag: "漫游中国",
        title: "西安",
        sub: "饱经岁月的古韵名城，沉淀着厚重秦汉唐文脉与悠然闲适的古城烟火",
      },
    ],
    about: {
      title: "关于我们",
      en: "ABOUT US",
      desc: "寰迹逸游，成立于2019年，是一家专注于为全球客户提供高品质、个性化旅行服务的专业运营商。历经稳健发展，公司已在业内树立良好口碑与品牌形象。",
    },
    enjoy: {
      en: "ENJOY ONESELF",
      title: "精选最佳旅游目的地",

      ratingLabel: "评分",
      destinations: [
        {
          tourName: "九寨黄龙都江堰6日深度定制之旅",
          location: "四川成都",
          rating: "4.9",
        },
        {
          tourName: "川渝双城记+9日奢享之旅",
          location: "四川成都+重庆",
          rating: "4.9",
        },
        {
          tourName: "北京7日6晚私人定制游",
          location: "北京",
          rating: "4.9",
        },
        {
          tourName: "遇长安•皆欢喜西安6日5晚私人定制游",
          location: "西安",
          rating: "4.9",
        },
      ],
    },
    travelGuide: {
      title: "一站式服务",
      en: "ONE-STOP SERVICE",
      items: {
        bcfw: {
          title: "包车服务",
          desc: "包车出行，随走随停。多种车型任选，专业司导全程陪同。贴心服务，让您出行无忧。",
        },
        cjly: {
          title: "酒店预订",
          desc: "甄选安缦、四季、丽思卡尔顿等顶奢酒店，按你的预算和需求精准匹配，你只管入住。",
        },
        qzbl: {
          title: "签证办理",
          desc: "专业团队一对一指导，从递签到出签每一步都有人盯，你只管准备出发。",
        },
        gnly: {
          title: "门票预订",
          desc: "热门景区提前锁票，再难订的票我们都有渠道，票在手说走就走。",
        },
        qydz: {
          title: "中国味道",
          desc: "地道中国味帮你订到位，热门餐厅提前代订，舌尖上的中国每一餐都帮你订好。",
        },
        srdz: {
          title: "主题旅游",
          desc: "按你的兴趣量身设计，实地踩线玩法，不走马观花，只深度沉浸。",
        },
      },
    },
    whyChoose: {
      en: "WHY CHOOSE US",
      title: "为什么选择寰迹",
      items: [
        {
          title: "真正纯玩 无购物店",
          desc: "每条线路都以舒适与真实体验感受为核心，无套路 无购物，让您安心感受当地文化、风景与故事，旅途更省心、更有意义。",
        },
        {
          title: "量身定制 贴心服务",
          desc: "根据您的时间、兴趣与预算，无论亲子、情侣还是企业团队，我们都将与您密切沟通，量身打造丰俭由人、契合个人风格的专属方案。",
        },
        {
          title: "从众到独 皆可成行",
          desc: "从一日游到精品小团，从家庭出游到企业考察，我们提供多种出行形态。无论目的与偏好如何，都有合适的产品满足您的期待。",
        },
        {
          title: "本地深耕 资源直采",
          desc: "深耕本地旅行社，一手资源实现高性价比，配当地向导、合规车辆与严选酒店，全程保障安全、品质舒适，为您的旅程提供支持。",
        },
      ],
    },
    reviews: {
      en: "CUSTOMER REVIEWS",
      title: "中国旅游客户评价与体验",
      intro:
        "在寰迹逸游，我们致力于为每一位旅客打造难忘的旅程。欢迎阅读来自世界各地游客的一手分享，了解他们在中国旅行中的真实体验与感受。",
      platforms: [
        {
          id: "facebook",
          name: "Facebook",
          ratingLabel: "Excellent",
          starTheme: "orange",
          reviews: [
            {
              author: "来自新加坡的客户",
              date: "2026年1月",
              rating: 5,
              title: "",
              content:
                "旅程非常舒适，必须给导游小刘点个大大的赞，我们带着两个老人，导游贴心的把所有事情都安排妥当，任何事情都不用我操心！酒店非常好，可以看到西安城墙，房间很大，还有浴缸，早餐丰盛。导游特意安排人少一些的时间段带我们去看秦始皇兵马俑，可以轻松的站在栏杆前看到兵马俑全貌并听导游讲解(讲解的很棒)，整体感观超出预期！长恨歌是一定要看的，演员表演和现场视觉效果手机拍不出来，特别好看！驼铃传奇也很好看！总之是一次非常满意、愉快的旅程！",
            },
          ],
        },
        {
          id: "instagram",
          name: "Instagram",
          ratingLabel: "Excellent",
          starTheme: "orange",
          reviews: [
            {
              author: "来自香港的客户",
              date: "2026年1月",
              rating: 5,
              title: "",
              content:
                "这次是带着父母来北京玩，圆父母看看首都的一个愿望，很庆幸遇到我们的导游杨师傅，老北京人，非常热情，工作认真负责，非常耐心，定制师每天的行程安排都提前和我沟通好，景点讲解细致入微，杨师傅还帮着我们照了不少的照片，全家都很满意，五星好评，下次旅游还会选择你们！朋友旅游首推你们。",
            },
          ],
        },
        {
          id: "tiktok",
          name: "TikTok",
          ratingLabel: "Excellent",
          starTheme: "orange",
          reviews: [
            {
              author: "来自马来西亚的客户",
              date: "2026年1月",
              rating: 5,
              title: "",
              content:
                "欲买桂花同载酒，终不似，少年游。跟好朋友踏上了中国的旅程，因为人生地不熟就选择了她们家的定制游，定制师根据我们的需求调整了3版行程，途中我们看了大熊猫、九寨沟和黄龙的五彩池，没想到，意外的收获了这么美的景色。不同于新疆喀纳斯的Tiffany蓝，九寨沟到处是神秘且深邃的湛蓝色，还有黄龙五彩池各种蓝交汇的如仙境般的宝地。还看到了透着果冻蓝的冰瀑布。淡季过来，人比较少，但淡季的风景已经这么好看了，估计6-10月的时候会更好看，有机会带父母过来看看。这几天吃的好、住的好、玩的好，去藏族家里做客吃饭，深深感受到了大口吃肉、大口喝酒、大声说话的洒脱与热情。最后，感谢定制师小陈、风趣幽默、尽职尽责的讲解服务，非常到位！",
            },
          ],
        },
      ],
    },
    contactForm: {
      title: "联系我们",
      subtitle: "寰迹逸游伴您一起漫游中国",
      email: "邮箱：hz@pangod.com",
      whatsapp: "WhatsApp/电话：15114070473",
      namePlaceholder: "您的姓名*",
      emailPlaceholder: "电子邮箱*",
      phonePlaceholder: "手机号码",
      messagePlaceholder: "留言内容*",
      submit: "提交",
      submitArrow: "→",
      submitHint: "获取旅游指南",
      required: "请填写必填项",
      submitSuccess: "提交成功，我们会尽快与您联系！",
      submitFail: "提交失败，请稍后重试",
    },
  },
  about: {
    title: "关于我们",
    en: "ABOUT US",
    p1Highlight: "寰迹逸游",
    p1Text:
      "，成立于2019年，是一家专注于为全球客户提供高品质、个性化旅行服务的专业运营商。历经稳健发展，公司已在业内树立良好口碑与品牌形象。",
    p2Title: "核心业务",
    p2Highlight: "核心业务",
    p2Text:
      "涵盖国内外定制旅行、团队出游及商务考察等多个领域。我们坚持以客户需求为导向，提供一站式、个性化的旅游解决方案。尤其在高端定制旅行方面，凭借丰富的行业经验、专业的策划团队与严谨的服务态度，为客户打造独一无二的旅行体验。",
    p2Prefix: "",
    p3Title: "集团公司",
    p3Highlight: "盘古纵横集团有限公司",
    p3Text:
      "寰迹逸游隶属于盘古纵横集团有限公司。集团源于2003年成立的成都盘古网络有限公司，总部位于成都，是一家集自主经营与投资孵化于一体的综合型企业，业务覆盖四川、重庆、山西、甘肃、北京及日本等地。集团主营业务包括广告、技术、金融、品牌宣传、日本民宿及酒店运营、跨境旅游服务等，先后孵化出盘古广告、盘古信息、福都典当、鸿钧品牌管理、日本Pangoo酒店及寰迹逸游等品牌。",
    p3Prefix: "",
    stats: {
      years: "年",
      yearsLabel: "经营经验",
      services: "项",
      servicesLabel: "休闲活动服务",
      team: "专业服务团队",
      satisfaction: "客户好评率",
    },
    culture: {
      title: "我们的文化",
      en: "CULTURE",
      items: [
        {
          title: "经营理念",
          en: "PHILOSOPHY",
          desc: "提供一个亲近大自然的机会，并享受一系列贴身服务和现代化的休闲和运动设施，放松身心。",
        },
        {
          title: "我们的愿景",
          en: "OUR VISION",
          desc: "提供一个亲近大自然的机会，并享受一系列贴身服务和现代化的休闲和运动设施，放松身心。",
        },
        {
          title: "我们的使命",
          en: "OUR MISSION",
          desc: "提供一个亲近大自然的机会，并享受一系列贴身服务和现代化的休闲和运动设施，放松身心。",
        },
      ],
    },
  },
  contact: {
    title: "联系我们",
    en: "CONTACT US",
    companyName: "公司名称：成都寰宇纵横国际旅行社有限公司",
    phone: "联系手机：15114070473",
    address: "联系地址：四川省成都市锦江区东大路318号2栋37层",
  },
  destinationRegion: {
    sectionLabel: "精选线路",
    sectionTitle: "{region}精选线路",
    regions: {
      sichuan: {
        tag: "漫游中国",
        title: "四川",
        sub: "风光旖旎的天府胜地，汇集奇绝秀美山川盛景与安逸悠然的巴蜀韵味",
      },
      chongqing: {
        tag: "漫游中国",
        title: "重庆",
        sub: "一座热情奔放的山水江城，坐拥雄奇险峻的山城地貌与热辣浓郁的市井风情",
      },
      beijing: {
        tag: "漫游中国",
        title: "北京",
        sub: "底蕴深厚的千年古都，兼具恢弘大气的皇城风貌与兼容并蓄的时代风华",
      },
      xian: {
        tag: "漫游中国",
        title: "西安",
        sub: "饱经岁月的古韵名城，沉淀着厚重秦汉唐文脉与悠然闲适的古城烟火",
      },
    },
  },
  destinationDetail: {
    buyNow: "立即预订 >>>",
    bookTour: "预订此行程",
    bookContact: "如有疑问，请致电 / WhatsApp：15114070473",
    labels: {
      tourCode: "行程代码",
      time: "时长",
      cities: "城市",
      accommodation: "住宿",
      hotel: "酒店",
      meals: "餐食",
    },
    highlightsTitle: "行程亮点",
    feeTitle: "费用说明",
    feeIncludedLabel: "费用包含",
    feeExcludedLabel: "费用不包含",
    feeRemarksLabel: "备注及其他",
    photosTitle: "我们的照片",
    photoTabs: {
      all: "全部",
      hotel: "合作酒店",
      vehicle: "旅游车辆",
      office: "公司环境",
      team: "团队合影",
    },
    list: [
      {
        heroTag: "",
        heroTitle: "天府之国·魅力四川",
        tourTitle: "九寨沟+黄龙+都江堰+熊猫谷｜四川全景定制游",
        tourRoute: "6天5晚 | 成都 · 都江堰 · 熊猫谷 · 黄龙 · 九寨沟",
        tourDesc: "",
        tourCode: "CT-SC-JZG-06",
        tourDays: "6天",
        tourCities: "成都-都江堰-黄龙-九寨沟",
        tourAccommodation: "景澜青棠 / 九寨沟西子礼白 / 龚禧里等",
        highlights: [
          "1对1定制：资深团队全程专属服务",
          "尊享座驾：豪华商务车，私密出行",
          "甄选住宿：品质酒店+特色主题",
          "深度体验：解锁本地小众玩法",
          "中文司导：专业可靠，沟通零障碍",
          "纯玩保障：正规资质，无购物",
          "无忧服务：一站搞定，省心到底",
        ],
        days: [
          {
            title: "Day1 抵达成都｜初遇蓉城烟火",
            hotel: "景澜青棠",
            route: "",
            meals: "",
            paragraphs: [
              "落地成都双流机场、天府机场或成都东站后，专车已在等候，无需拖着行李等车。",
              "直达顶流商圈——春熙路、IFS爬墙熊猫、太古里，一路逛吃拍，随手就是时尚大片。入夜后，街头啃兔头、尝冰粉，沉浸式感受成都独有的松弛感。",
            ],
          },
          {
            title: "Day2 都江堰+熊猫谷｜治愈拉满",
            hotel: "景澜青棠",
            route: "",
            meals: "",
            paragraphs: [
              "清晨直奔熊猫谷，竹林溪涧里偶遇小熊猫和滚滚，软萌治愈。",
              "下午漫步都江堰，打卡鱼嘴、飞沙堰，感受古人治水智慧。",
              "傍晚灌县古城逛吃，夜游南桥看「蓝眼泪」，岷江波光粼粼，氛围感拉满。别忘了仰天窝广场的巨型熊猫，随手一拍都出片。",
            ],
          },
          {
            title: "Day3 奔赴黄龙｜人间瑶池仙境",
            hotel: "九寨沟 西子礼白",
            route: "",
            meals: "",
            paragraphs: [
              "成都东站乘高铁直达黄龙九寨站，一路高原风光，治愈感拉满。",
              "🏔打卡5A级黄龙景区，坐索道上山省力省心。五彩池如梯田彩池，阳光下蓝绿渐变，宛如打翻的调色盘，梦幻至极。",
              "夜宿九寨沟沟口，养足精神，静待次日童话世界。",
            ],
          },
          {
            title: "Day4 九寨沟一日游｜走进童话水景",
            hotel: "九寨沟 西子礼白",
            route: "",
            meals: "",
            paragraphs: [
              "全天沉浸九寨沟！Y型三条沟串联起海子与瀑布，藏寨炊烟映着雪山，每一帧都像童话电影🎬。",
              "不赶路，老人小孩也能轻松游。五花海、珍珠滩、芦苇海……随手一拍都是壁纸。",
              "亲眼见过才懂——「九寨归来不看水」。",
            ],
          },
          {
            title: "Day5 成都慢生活｜老蓉城深度游",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "清晨，在人民公园鹤鸣茶社坐下，一盏盖碗茶配上采耳，体验老成都的慢生活「天花板」。",
              "下午，漫步宽窄巷子与杜甫草堂。竹林茅舍间，感受诗圣的家国情怀，随手拍出古风大片。",
              "入夜，前往东郊记忆，体验「蜀宴赋」汉服餐秀。边享美食边看沉浸式演出，氛围感瞬间拉满。",
            ],
          },
          {
            title: "Day6 武侯祠+返程｜三国烟火收尾",
            hotel: "龚禧里",
            route: "",
            meals: "",
            paragraphs: [
              "上午漫步武侯祠，红墙竹影间品味三国风云。隔壁锦里古街，红灯笼高挂，满街川味烟火。",
              "午后专车送机，不必匆忙，慢悠悠为旅程画上句号。",
            ],
          },
        ],
        feeIncluded: "行程中列出的景点门票、酒店、餐饮、导游和用车。",
        feeExcluded:
          "国际/国内机票和税费、个人旅行和医疗保险、签证费、个人开支以及不可抗力（如航班延误、自然灾害、战争等）造成的额外费用。",
      },
      {
        heroTag: "",
        heroTitle: "川渝双城记+9日奢享之旅",
        heroLocation: "四川成都+重庆",
        tourTitle: "川渝双城记+9日奢享之旅｜国宝熊猫·麻辣火锅·8D魔幻重庆",
        tourRoute: "9天8晚 | 成都 · 九寨沟 · 都江堰 · 重庆 · 武隆",
        tourCode: "CT-SC-CQ-09",
        tourDays: "9天",
        tourCities: "成都-九寨沟-都江堰-重庆-武隆",
        tourAccommodation: "托尼洛·兰博基尼/金龙国际/温德姆/豪生/喜来登等",
        highlights: [
          "1对1定制：资深团队全程专属服务",
          "尊享座驾：豪华商务车，私密出行",
          "甄选住宿：品质酒店+特色主题",
          "深度体验：解锁本地小众玩法",
          "中文司导：专业可靠，沟通零障碍",
          "纯玩保障：正规资质，无购物",
          "无忧服务：一站搞定，省心到底",
        ],
        days: [
          {
            title: "Day1 抵达成都｜初遇蓉城烟火",
            hotel: "成都托尼洛·兰博基尼酒店",
            route: "",
            meals: "",
            paragraphs: [
              "落地成都双流机场、天府机场或成都东站后，专车已在等候，无需拖着行李等车。",
              "直达顶流商圈——春熙路、IFS爬墙熊猫、太古里，一路逛吃拍，随手就是时尚大片。入夜后，街头啃兔头、尝冰粉，沉浸式感受成都独有的松弛感。",
            ],
          },
          {
            title: "Day2 成都-熊猫谷-前往九寨沟",
            hotel: "九寨沟金龙国际度假酒店",
            route: "",
            meals: "",
            paragraphs: [
              "上午｜熊猫谷：步入竹林掩映的生态秘境，近距离观察国宝大熊猫的日常生活。溪涧潺潺，绿意盎然，随手一拍都是治愈系画面。",
              "下午｜奔赴九寨——沿著名的「九环线」北上，穿行于川西高原腹地。窗外雪山巍峨、草甸辽阔，高原风光一路相伴，直抵「人间仙境」。",
            ],
          },
          {
            title: "Day3 九寨沟深度游",
            hotel: "九寨沟金龙国际度假酒店",
            route: "",
            meals: "",
            paragraphs: [
              "全天漫游九寨沟风景区，景区呈「Y」字形分布，我们将依次探访树正沟、诺日朗瀑布、五花海、珍珠滩瀑布、长海及五彩池等核心景点。",
              "碧湖叠瀑、彩林雪峰，一步一景，沉浸于「人间仙境」的绝色画卷之中。",
            ],
          },
          {
            title: "Day4 九寨沟-藏族风情街-川主寺",
            hotel: "松潘川主寺戴斯精选温德姆酒店",
            route: "",
            meals: "",
            paragraphs: [
              "上午前往藏族风情街，沉浸式感受藏地文化，欣赏独具特色的手工艺品。随后参观藏传佛教寺院——川主寺，在梵音经幡间体会信仰的宁静。",
              "下午乘大巴出发，途经松潘、茂县，一路沿岷江峡谷南下，前往世界水利文化的鼻祖——都江堰市。",
            ],
          },
          {
            title: "Day5 都江堰-成都-重庆",
            hotel: "青城（豪生）国际酒店",
            route: "",
            meals: "",
            paragraphs: [
              "上午参观都江堰水利工程，探访鱼嘴分水堤、飞沙堰溢洪道、宝瓶口进水口，近距离感受两千年前古人「因势利导」的治水智慧。",
              "下午返回成都，换乘高铁前往「山城」重庆，开启另一座魔幻都市的探索之旅。",
            ],
          },
          {
            title: "Day6 武隆天坑三桥-仙女山",
            hotel: "重庆福朋喜来登酒店",
            route: "",
            meals: "",
            paragraphs: [
              "上午探索世界自然遗产天坑三桥，这里是电影《变形金刚：绝迹重生》的取景地。徒步其间，仰望天龙桥、青龙桥、黑龙桥三座天然石拱桥拔地而起，气势磅礴。",
              "下午前往被誉为「东方瑞士」的仙女山国家森林公园，漫步广阔而宁静的高山草原，林海、草甸、牛羊成群，仿佛置身阿尔卑斯。",
            ],
          },
          {
            title: "Day7 乌江画廊-九黎城/龚滩古镇",
            hotel: "武隆哈希国际大酒店",
            route: "",
            meals: "",
            paragraphs: [
              "上午前往武隆，沿途欣赏乌江画廊——百里山水如诗如画，碧水青山相映成趣。",
              "途中可选参观九黎城（体验苗族深厚文化）或龚滩古镇（感受千年古镇的江畔韵味），领略渝东南独特的人文风情。",
            ],
          },
          {
            title: "Day8 李子坝-磁器口-洪崖洞",
            hotel: "重庆福朋喜来登酒店",
            route: "",
            meals: "",
            paragraphs: [
              "上午前往李子坝观景台，打卡轻轨穿楼而过的魔幻奇观。随后漫步城市地标解放碑步行街，感受山城的繁华与活力。",
              "下午探访磁器口古镇，走一走青石板老街，寻访神奇的洪崖洞——夜幕下的吊脚楼灯火璀璨，宛如现实版《千与千寻》。",
            ],
          },
          {
            title: "Day9 重庆 → 温馨返程",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "根据您的航班或火车时刻，安排私家车准时接送至重庆江北国际机场或高铁站，结束这场川渝双城的愉快旅程。",
            ],
          },
        ],
        feeIncluded: "行程中列出的景点门票、酒店、餐饮、导游和用车。",
        feeExcluded:
          "国际/国内机票和税费、个人旅行和医疗保险、签证费、个人开支以及不可抗力（如航班延误、自然灾害、战争等）造成的额外费用。",
        feeRemarks: [
          "本行程安排仅供参考，适用于行前规划。最终的行程及相关服务内容，请以我方出具的《旅游确认函》为准。",
          "如遇政府征用等不可抗力因素，原定酒店将替换为同级别或更高标准的酒店，恕不另行指定。最终入住的酒店以正式行程单中载明的内容为准。",
        ],
      },
      {
        heroTag: "",
        heroTitle: "北京7日6晚私人定制游",
        tourTitle: "「京韵七日夜·古今漫行记」",
        tourDesc: "北京7日6晚私人定制游「从升旗开始·到胡同归心」",
        tourRoute: "7天6晚 | 天安门 · 故宫 · 长城 · 颐和园 · 胡同",
        tourCode: "CT-BJ-07",
        tourDays: "7天",
        tourCities: "北京",
        tourAccommodation: "国宏宾馆/前门区域/奥体附近/四合院酒店等",
        highlights: [
          "1对1定制：资深团队全程专属服务",
          "尊享座驾：豪华商务车，私密出行",
          "甄选住宿：品质酒店+特色主题",
          "深度体验：解锁本地小众玩法",
          "中文司导：专业可靠，沟通零障碍",
          "纯玩保障：正规资质，无购物",
          "无忧服务：一站搞定，省心到底",
        ],
        days: [
          {
            title: "Day1 落地北京-专车接机-酒店入住-自由活动",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "抵达首都，专车接机免去交通烦恼，入住后可根据体力和时间，选择附近商圈（如西单、王府井）简单逛吃，调整状态迎接接下来的行程。",
              "【住宿建议】建议住国宏宾馆或前门区域，方便次日早起看升旗。外宾入住需携带护照原件，酒店前台做境外人员住宿登记。",
            ],
          },
          {
            title: "Day2 升旗仪式-天坛公园-故宫博物院-杨梅竹斜街",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】当晚建议仍住前门/天安门区域，步行回酒店方便；也可选择住什刹海附近的四合院酒店（如什刹海紫檀文化酒店），沉浸式体验老北京风情。",
              "天不亮就出发去天安门广场。看国旗和太阳一同升起，全场安静——这是中国一天的开始。",
              "随后前往天坛。祈年殿的蓝色屋顶非常美丽。在回音壁拍拍手，声音会沿着墙传出去，很有趣。",
              "中午进入故宫。从午门走到神武门，经过太和殿、乾清宫和御花园。太和殿前的广场非常宽阔。珍宝馆里的皇家首饰和钟表很精致，值得一看。",
              "傍晚来到杨梅竹斜街。这条胡同安静、有生活气息。可以看到本地人居住的样子：煤炉、鸽子、晾衣绳。找一家二楼的咖啡馆坐下，看灰色的屋顶延伸到远方。",
              "这一天，从庄严的仪式走到日常的胡同。你会看到两个不同的北京。",
            ],
          },
          {
            title: "Day3 慕田峪长城-奥林匹克公园-鸟巢-水立方",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】当晚建议住朝阳区奥体附近（如北辰洲际），逛完直接回酒店休息；或返回市区住国宏宾馆（约40分钟车程）。",
              "早上出发去慕田峪长城。这里的游客比八达岭少，风景更开阔。坐缆车上山，站在长城上往两边看，城墙像一条巨龙蜿蜒在山脊上，一眼望不到头。下山可以选择滑道，像坐小车一样从树林里转下来，大人小孩都喜欢。",
              "下午回到市区，去奥林匹克公园。鸟巢的钢结构像编织的大鸟窝，水立方在阳光下像一块蓝色泡泡。傍晚亮灯后更漂亮——鸟巢变成暖红色，水立方变成深蓝色，两个建筑挨在一起，非常上镜。",
              "这一天，从古老的长城走到现代的奥运场馆。两千年的防御工事和二十年的体育地标，都在同一天里看到了。",
            ],
          },
          {
            title: "Day4 颐和园-圆明园-鼓楼烟袋斜街",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】当晚建议住海淀区/西城区交界，或返回国宏宾馆（地铁9号线直达）。",
              "上午去颐和园。沿着长廊散步，看十七孔桥横在湖面上，佛香阁立在半山腰——皇帝避暑的地方，确实凉快。",
              "下午去圆明园。只看西洋楼遗址，大水法的石头还在那里站着。不多说，看一眼就懂了。",
              "傍晚去鼓楼和烟袋斜街。鼓楼红墙灰瓦，是老北京的地标。旁边的烟袋斜街窄窄弯弯，卖糖葫芦、小玩意儿，抬头就能看见鼓楼的影子。",
              "一天下来：从皇家园林走到废墟，再走进热闹的胡同。",
            ],
          },
          {
            title: "Day5 雍和宫-孔庙国子监博物馆-五道营胡同",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】当晚建议住雍和宫/北新桥附近，步行可达各景点。",
              "上午去雍和宫。香火很旺，大殿里的檀木大佛很高，记得顺时针转转经筒。",
              "隔壁就是孔庙和国子监。孔庙石碑上刻着历代进士的名字，国子监是古代的最高学府，琉璃牌坊很漂亮。",
              "傍晚拐进五道营胡同。安静、不挤，灰砖墙后面藏着咖啡馆和小店。坐下来喝杯东西，看窗外的人慢慢走过。",
              "一天下来：从寺院到学堂，再坐进胡同咖啡馆。",
            ],
          },
          {
            title: "Day6 国家博物馆-恭王府",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】当晚可继续住东城区，方便次日自然醒后去机场/火车站。",
              "上午去国家博物馆。「古代中国」展厅从原始人到明清，课本里的国宝都在眼前：后母戊鼎、四羊方尊、金缕玉衣。",
              "下午去恭王府。和珅的旧居，后花园比故宫的还讲究。别忘了摸一摸「福」字碑，据说能带好运回家。",
              "一天下来：从全中国的宝贝，走进一家人的讲究。",
            ],
          },
          {
            title: "Day7 睡到自然醒-送站送机返程",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "最后一天，不用定闹钟。睡到自然醒，慢慢吃顿早餐。收拾好行李，看一眼窗外的北京。",
              "根据航班或火车时间，专车来接你。路上可以翻翻这几天的照片：天安门的升旗、长城上的风、胡同里的咖啡、故宫的红墙……",
              "车子往机场或火车站开，北京在身后越来越远。七天走下来，这个城市应该已经在你的记忆里了。一路平安，欢迎再来。",
            ],
          },
        ],
        feeIncluded: "行程中列出的景点门票、酒店、餐饮、导游和用车。",
        feeExcluded:
          "国际/国内机票和税费、个人旅行和医疗保险、签证费、个人开支以及不可抗力（如航班延误、自然灾害、战争等）造成的额外费用。",
        feeRemarks: [
          "本行程安排仅供参考，适用于行前规划。最终的行程及相关服务内容，请以我方出具的《旅游确认函》为准。",
          "如遇政府征用等不可抗力因素，原定酒店将替换为同级别或更高标准的酒店，恕不另行指定。最终入住的酒店以正式行程单中载明的内容为准。",
        ],
      },
      {
        heroTag: "",
        heroTitle: "遇长安•皆欢喜西安6日5晚私人定制游",
        tourTitle: "「从城墙根下，到不夜城里」",
        tourDesc: "西安6日5晚私家团丨一单一团丨不拼车",
        tourRoute: "6天5晚 | 兵马俑 · 华山 · 壶口 · 大雁塔 · 不夜城",
        tourCode: "CT-XA-06",
        tourDays: "6天",
        tourCities: "西安-华山-壶口",
        tourAccommodation: "Moxy酒店/玉·酒店/华山客栈等",
        highlights: [
          "1对1定制：资深团队全程专属服务",
          "尊享座驾：豪华商务车，私密出行",
          "甄选住宿：品质酒店+特色主题",
          "深度体验：解锁本地小众玩法",
          "中文司导：专业可靠，沟通零障碍",
          "纯玩保障：正规资质，无购物",
          "无忧服务：一站搞定，省心到底",
        ],
        days: [
          {
            title: "Day1 落地西安-24小时专车接机/站后入住酒店",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】西安城市中心Moxy酒店。",
              "到达酒店后凭有效证件办理入住手续，酒店一般入住时间为14:00之后，如您到达较早，可将行李寄存在前台，在酒店周围逛逛稍作等待。",
              "当日自由活动-推荐：钟鼓楼广场、回民街【自由选择】。",
            ],
          },
          {
            title:
              "Day2 【穿越秦唐】兵马俑博物馆→无线耳麦+人工讲解→VR电影或秦俑手工制作二选一→华清宫",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】玉·酒店（西安华清宫店）。",
              "上午去兵马俑。八千多个陶俑排成军阵，每一个面孔都不一样。无线耳麦听讲解，结束后选VR电影或亲手做个小兵马俑。",
              "下午去华清宫。唐朝皇帝和杨贵妃的温泉行宫，背靠骊山，温泉水还在流。",
              "晚上推荐看演出：《西安千古情》或《驼铃传奇》，大场面、真骆驼，外宾都爱看。",
              "一天走完秦朝和唐朝。",
            ],
          },
          {
            title:
              "Day3 【攀登高峰，尽享美景】早餐-华山（赠登山能量包）-入住市区酒店",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】华山客栈。",
              "早上出发去华山。中国最险的山，武侠小说里高手比剑的地方。乘缆车上山，沿悬崖边走。山顶看群山像波浪铺开。送你登山能量包。傍晚回市区酒店。腿酸，但值了。",
            ],
          },
          {
            title: "Day4 【壶口观瀑】西安-酒店上门接-壶口瀑布-宿西安",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】西安城市中心Moxy酒店。",
              "早上酒店接你，乘车前往壶口瀑布。黄河在这里被两岸岩石挤进一道窄窄的峡谷，水花飞起来几十米高，声音隔着很远就能听到。站在岸边，水雾打在脸上，你会明白为什么黄河叫「母亲河」——汹涌，但有一种让人敬畏的力量。傍晚返回西安市区酒店。",
            ],
          },
          {
            title:
              "Day5 【话长安•归故里】西安博物院（小雁塔）-大雁塔-赠汉服妆造-夜游大唐不夜城/音乐喷泉",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】西安城市中心Moxy酒店。",
              "上午看小雁塔，安静的老塔，旁边就是西安博物院，听听长安城的老故事。",
              "下午去大雁塔，玄奘翻译佛经的地方。可以爬上去，看西安城全景。",
              "然后换汉服、做妆造——穿上之后走路上，你就是从唐朝来的。拍照特别好看。",
              "晚上别眨眼。大唐不夜城亮了灯，满街穿汉服的人，像走进了电影里。大雁塔喷泉跟着音乐冲上天，水花哗哗的。看完车送你回酒店。这一天，你也是长安故事里的人。",
            ],
          },
          {
            title: "Day6 【睡到自然醒】-自由活动-24h专车送机/站返程",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "【住宿建议】西安城市中心Moxy酒店。",
              "最后一天，没有闹钟。睡到自然醒，慢慢吃顿早餐。",
              "剩下的时间是你的。可以在酒店附近逛逛，买点伴手礼，或者就在房间里翻翻这几天的照片。",
              "根据航班或火车时间，专车准时来接你。车子往机场或火车站开，西安在身后越来越远。",
              "六天走下来，这座城应该已经住进你心里了。一路平安，欢迎再来。",
            ],
          },
        ],
        feeIncluded: "行程中列出的景点门票、酒店、餐饮、导游和用车。",
        feeExcluded:
          "国际/国内机票和税费、个人旅行和医疗保险、签证费、个人开支以及不可抗力（如航班延误、自然灾害、战争等）造成的额外费用。",
        feeRemarks: [
          "本行程安排仅供参考，适用于行前规划。最终的行程及相关服务内容，请以我方出具的《旅游确认函》为准。",
          "如遇政府征用等不可抗力因素，原定酒店将替换为同级别或更高标准的酒店，恕不另行指定。最终入住的酒店以正式行程单中载明的内容为准。",
        ],
      },
    ],
  },
  strategy: {
    title: "游玩攻略",
    en: "PLAY GUIDE",
  },
  guide: {
    bcfw: {
      en: "CHARTER SERVICE",
      title: "旅游定制包车·专属出行",
      paragraphs: [
        "全程专车接送，不拼车、不绕路，时间完全由你掌控。熟悉路况的本地司机，带你避开拥堵，直达景区核心。车内备有矿泉水、充电线，宽敞舒适，老人孩子都能安心休息。无需拖着行李挤地铁、等出租，每个景点无缝衔接。适合家庭出游、外宾接待、深度小团——把路上的时间省下来，留给风景。",
      ],
    },
    cjly: {
      en: "HOTEL BOOKING",
      title: "定制奢华酒店·私属礼遇",
      paragraphs: [
        "甄选安缦、四季、丽思卡尔顿等顶奢酒店，每一家都经实地考察，亲子游选有儿童乐园的，带老人选带电梯和营养餐的，情侣出行找私密有格调的。从经济连锁到精品设计，按你的预算和需求精准匹配。不用自己熬夜比价、翻几百条评论——我们帮你选好，你只管入住。",
      ],
    },
    gnly: {
      en: "TICKET BOOKING",
      title: "门票预订·快人一步",
      paragraphs: [
        "热门景区提前锁票，免去蹲点抢票的焦虑。故宫、兵马俑、迪士尼、环球影城——再难订的票我们都有渠道。不用排队换票，刷证或扫码直接入园。遇到售罄、限流、临时闭园？我们帮你改签、退换、找替代方案。票在手，说走就走。",
      ],
    },
    qydz: {
      en: "CHINESE FLAVORS",
      title: "特色美食·一席难求",
      paragraphs: [
        "北京烤鸭、西安羊肉泡馍、成都火锅——地道中国味，我们帮你订到位。全聚德、大董、老字号、黑珍珠，热门餐厅提前代订，无需排队。包间、景观桌、忌口过敏，提前安排。不催单、不等位、不踩雷。舌尖上的中国，每一餐都帮你订好。",
      ],
    },
    qzbl: {
      en: "VISA SERVICE",
      title: "签证办理·省心省力",
      paragraphs: [
        "专业团队一对一指导，材料清单清晰明了，不用自己猜、不用反复跑。疑难杂症（白本、拒签史、在职证明难开）都有应对方案。加急通道、表格代填、翻译件全包，进度实时可查。从递签到出签，每一步都有人盯。把麻烦留给我们，你只管准备出发。",
      ],
    },
    srdz: {
      en: "THEMED TRAVEL",
      title: "主题旅游·玩得不一样",
      paragraphs: [
        "不止是看风景，更是圆一场梦。亲子研学、蜜月旅拍、禅修静心、美食探店、户外探险——按你的兴趣量身设计。实地踩线的玩法、当地人带的路、避开游客的私藏机位。从行程到住宿到体验，全都围绕一个主题展开。不走马观花，只深度沉浸。",
      ],
    },
  },
};
